import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import { isLoggedIn } from '../Login/selectors'

function NotLoggedInRoute({ isLoggedIn, component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props => !isLoggedIn ? (
        <Component {...props} />
      ) : (
        <Redirect to='/' />
      )}
    />
  )
}

NotLoggedInRoute.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired
}

const mapStateToPros = createStructuredSelector({ isLoggedIn })
const connector = connect(mapStateToPros)

export default connector(NotLoggedInRoute)
